export class AjustageOxygene {

    Code: string
    Saturation: number
    Pression: number
    Pente: number
    get Conforme() {
        const lowerBound = 80;
        const upperBound = 120;
        return this.Saturation >= lowerBound && this.Saturation <= upperBound;
    }

    toJSON() {
        let ms: any = Object.assign({}, this)
        ms.Conforme = this.Conforme;
        return ms;
    }

    static mapFromJSON(json: any): AjustageOxygene {
        const ms = new AjustageOxygene();

        ms.Code = json.code;
        ms.Saturation = json.saturation;
        ms.Pression = json.pression;
        ms.Pente = json.pente;
        // ms.Conforme = json.conforme;

        return ms;
    }
}